module.exports = __webpack_public_path__ + "img/expand-02.f8c2807d.svg";